import {
  ContentLayer,
  ContentLayerBody,
  ContentLayerBottomBar,
} from '@travel-frontend/ui-components';
import {useTranslation} from 'react-i18next';

import {testId} from '@/utils/testId';

type Props = {
  isOpen: boolean;
  controls: React.ReactNode;
  selectedFilters?: React.ReactNode;
  children: React.ReactNode;
  onClose: () => void;
};

export const FilterOverlay: React.FunctionComponent<Props> = ({
  children,
  isOpen,
  controls,
  selectedFilters,
  onClose,
}) => {
  const {t} = useTranslation('general');

  return (
    <ContentLayer
      open={isOpen}
      onClose={onClose}
      title={t('filterOverlay.title')}
      closeButtonLabel=""
      data-testid={testId('mobile-filter-overlay')}
    >
      {selectedFilters}
      <ContentLayerBody>{children}</ContentLayerBody>
      <ContentLayerBottomBar>{controls}</ContentLayerBottomBar>
    </ContentLayer>
  );
};
